import styled from "styled-components";

export const ResumecontentDiv = styled.div`
  color: #fff;
  margin-bottom: 30px;
  margin-right: 50px;
  padding-left: 50px;
  @media screen and (max-width: 820px) {
    align-items: center;
    margin-bottom: 30px;
    margin-right: 15px;
    padding-left: 15px;
  }
`;
export const Links = styled.a`
  text-decoration: none;
  color: ${({ light }) => (light ? "#c62828" : "#009688")};
`;

export const ResumeContentTitle = styled.h1`
  text-align: center;
  padding: 100px 0 20px 0;
  color: ${({ light }) => (light ? " #272727" : " #f7f8fa")};
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  letter-spacing: 1.5px;
  font-size: 40px;

  @media screen and (max-width: 820px) {
    padding: 95px 0 20px 0;
  }
`;

export const ResumeDivCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #497e76;
  border-radius: 15px;
  margin-bottom: 15px;
`;

export const ResumeCarImg = styled.img`
  width: 15%;
  padding: 20px 0 20px 0px;
`;

export const ResumeCardMeta = styled.div`
  padding: 10px 0 20px 20px;
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export const ResumeCardTitle = styled.h1`
  padding-bottom: 5px;
  color: ${({ light }) => (light ? " #272727" : " #a9b3c1")};
  @media screen and (max-width: 820px) {
    font-size: 18px;
  }
`;

export const ResumeCardSubTitle = styled.h4`
  padding-bottom: 5px;
  color: ${({ light }) => (light ? " #272727" : " #f7f8fa")};
  @media screen and (max-width: 820px) {
    font-size: 12px;
  }
`;

export const ResumeCardText = styled.p`
  max-width: 600px;
  color: ${({ light }) => (light ? " #666666" : " #f7f8fa")};
  @media screen and (max-width: 820px) {
    font-size: 10px;
  }
`;
